module.exports = __webpack_public_path__ + "assets/images/sprites/sort_both.png";